export default "__VITE_ASSET__24db32dd__"